// «واتس‌اپ پارسینا» — the company number's link state, and the two things an
// operator may do to it.
//
// The pairing conversation is NOT here: codes rotate every ~20 seconds and the
// link completes on the gateway's own socket, so it is streamed from
// `GET /integrations/whatsapp/pairing` and read by the kit's
// `useWhatsappPairing`. A code carried on a query would be dead before it
// rendered.

export const SESSION_QUERY = `
  query PlatformWhatsappSession {
    platformWhatsappSession {
      accountId
      state
      phone
      deviceLabel
      linkedAt
      detail
      sentLastHour
      maxPerHour
      sendDisabled
      configured
    }
  }
`;

export const UNLINK = `
  mutation UnlinkPlatformWhatsapp {
    unlinkPlatformWhatsapp
  }
`;

export const SEND_TEST = `
  mutation SendPlatformWhatsappTest($phone: String!) {
    sendPlatformWhatsappTest(phone: $phone) {
      sent
      detail
    }
  }
`;

/** Where the BFF proxies the gateway's pairing stream. */
export const PAIRING_PATH = '/integrations/whatsapp/pairing';
